define(
    [
        'jquery',
        'backbone',
        'underscore',
        'assets/js/modules/designPreview/dvvPageParamsExtractor',
        'assets/js/modules/product/model/attributeModel',
        'assets/js/modules/browser',
        'assets/js/modules/option/optionValueModel',
        'assets/js/modules/popup/Popup',
        'assets/js/modules/translator',
        'assets/js/modules/design/designModel',
        'assets/js/modules/designPreview/dvvParams'
    ],
    function($, backbone, _, dvvPageParamsExtractor, AttributeModel, browser, OptionValueModel, Popup, translator, DesignModel, DvvParams) {
        const commonParams = DvvParams.getCommonParams();

        var dvvPreview = backbone.View.extend({
            params: null,
            DVV: null,
            DVVpopup: null,
            DVV_PATH: '<%= dvvUrl %>',
            isLoaded: false,
            isInitialised: false,
            isInverseFolding: false,
            enlargePopUpActive: false,
            preloaderActive: false,
            foldCode: '',
            orientation: null,
            //lock product rotation by one or two axis, see DVV documentation
            lockAxis: commonParams.lockAxis,
            limitAxis: commonParams.limitAxis,
            worldAxis: commonParams.worldAxis,

            primaryViewerSelector: '#davinciViewer',
            popupViewerSelector: '#embdedDavinciViewer',

            POPUP_PREVIEW_WIDTH: 800,
            POPUP_PREVIEW_HEIGHT: 700,

            popupTmpl: _.template(
                [
                    '<div id="design-peview-popup" class="preview-popup">',
                    '<div id="embdedDavinciViewer"></div>',
                    '<div id="popup-dvv-buttons">',
                    '<div class="button-container">',
                    '<button type="button" id="popup-folding-close" class="btn btn-medium btn-secondary folding-controls" data-goto="close"></button>',
                    '<button type="button" id="popup-dvv-pause" class="btn btn-medium btn-secondary" data-goto="pause">' +
                        translator.trans('approval.options.folding.pause', {}, 'approval') +
                        '</button>',
                    '</div>',
                    '</div>',
                    '</div>'
                ].join('')
            ),

            enlargeOverlayTmpl: _.template('<div class="enlarge-overlay"></div>'),

            loadingOverlayTmpl: _.template('<div class="loading-overlay blocks-spinner"></div>'),

            events: {
                'click button#folding-close': 'dvvAnimationChange',
                'click button#dvv-pause': 'dvvAnimationChange',
                'click input#folding-flip-top': 'render' // Change Direction
            },

            dvvAnimation: {
                open: {
                    goto: 'close',
                    text: 'Close Fold'
                },
                close: {
                    goto: 'open',
                    text: 'Open Fold'
                },
                play: {
                    goto: 'pause',
                    text: 'Pause'
                },
                pause: {
                    goto: 'play',
                    text: 'Play'
                }
            },

            initialize: function(options, params) {
                var _this = this;
                this.params = params;
                this.orientation = options.model.get('orientation');

                this.once(
                    'load:dvv',
                    function() {
                        if (params.enlargePopup) {
                            this.initPopUp();
                        }
                        if (params.preloader) {
                            this.initPreloader();
                        }
                        this.render();
                    },
                    this
                );

                this.once(
                    'init:dvv',
                    function() {
                        // prevent double rendering for synchronous turning folding controls
                        var renderAction = _.debounce(this.render, 250);
                        this.listenTo(this.model, 'change', renderAction);
                    },
                    this
                );

                // Assign elements
                this.$foldingControls = this.$el.find('.folding-controls');
                this.$foldingCloseBtn = this.$el.find('button#folding-close');
                this.$dvvPauseBtn = this.$el.find('button#dvv-pause');
                this.$flipTopControl = this.$el.find('#folding-flip-top');

                this.loadDVVjs(params.dvvUrl);

                $(this.primaryViewerSelector).on('click', function() {
                    _this.toggleDvvBtn(_this.$dvvPauseBtn, 'pause');
                });
            },

            render: function() {
                this.$primaryViewer = this.$el.find(this.primaryViewerSelector);

                if (this.isInitialised) {
                    this.DVV.destroy();
                    this.$primaryViewer.children('canvas').remove();
                }

                if (this.model.get('isSample') === true && this.model.get('productContext').get('samples').length === 0) {
                    this.$el.hide();
                } else {
                    this.$el.show();
                }

                this.trigger('start:render');

                let foldingMap = {};
                if (this.params.designerConfig !== undefined && this.params.designerConfig.foldingMap !== undefined) {
                    foldingMap = this.params.designerConfig.foldingMap;
                }

                this.updateFolding(this.model.get('optionsContext').get('folding'), foldingMap);
                this.paramsCache = this.generateDVVParams({
                    lockAxis: this.lockAxis,
                    limitAxis: this.limitAxis,
                    worldAxis: this.worldAxis,
                    inverseFolding: this.isInverseFolding,
                    circleCanvas: this.model.get('productContext').get('shape') === AttributeModel.VALUE_SHAPE_CIRCLE,
                    designerConfig: this.params.designerConfig
                });

                this.DVV = new opensoft.DavinciViewer(this.$primaryViewer.prop('id'), this.paramsCache);
            },

            initPreloader: function() {
                var _this = this;

                // Primary Viewer Preloader
                this.on('start:render', function() {
                    _this.$loadingOverlay = $(_this.loadingOverlayTmpl());
                    _this.$primaryViewer.prepend(_this.$loadingOverlay.show());
                });
                this.on('init:dvv', function() {
                    _this.$loadingOverlay.remove();
                });

                // Popup Viewer Preloader
                this.on('start:popup-render', function() {
                    _this.$popUpLoadingOverlay = $(_this.loadingOverlayTmpl());
                    _this.$popupViewer.prepend(_this.$popUpLoadingOverlay.show());
                });
                this.on('init:dvv-popup', function() {
                    _this.$popUpLoadingOverlay.remove();
                });

                this.preloaderActive = true;
            },

            initPopUp: function() {
                var _this = this;
                var $popupEl = $(this.popupTmpl());
                this.$popupViewer = $popupEl.find(this.popupViewerSelector);
                this.$enlargeOverlay = $(this.enlargeOverlayTmpl());
                this.enlargePopUpActive = true;

                this.popup = new Popup($popupEl, {
                    width: this.POPUP_PREVIEW_WIDTH,
                    height: this.POPUP_PREVIEW_HEIGHT,
                    closeText: 'close',
                    open: function() {
                        if (_this.DVV && _this.DVV.destroy) {
                            _this.DVV.destroy();
                        }

                        _this.trigger('start:popup-render');

                        _this.DVVpopup = new opensoft.DavinciViewer(
                            _this.$popupViewer.prop('id'),
                            _this.generateDVVParams({
                                lockAxis: this.lockAxis,
                                limitAxis: this.limitAxis,
                                worldAxis: this.worldAxis,
                                isPopUpPreview: true,
                                inverseFolding: _this.isInverseFolding,
                                circleCanvas: _this.model.get('productContext').get('shape') === AttributeModel.VALUE_SHAPE_CIRCLE,
                                designerConfig: _this.params.designerConfig
                            })
                        );

                        _this.initDvvButtonsPopup();
                    },
                    close: function() {
                        _this.$enlargeOverlay.hide();
                        _this.DVVpopup && _this.DVVpopup.destroy && _this.DVVpopup.destroy();
                        _this.$popupViewer.children('canvas').remove();
                        _this.$popupFoldingCloseBtn.off('click');
                        _this.$popupDvvPauseBtn.off('click');
                        _this.render();
                    }
                });

                this.on('init:dvv', function() {
                    _this.$primaryViewer.prepend(this.$enlargeOverlay).hover(
                        function() {
                            _this.$enlargeOverlay.fadeIn();
                        },
                        function() {
                            _this.$enlargeOverlay.fadeOut();
                        }
                    );

                    if (_this.$primaryViewer.is(':hover')) {
                        _this.$enlargeOverlay.show();
                    }

                    _this.$enlargeOverlay.on('click', function() {
                        _this.popup.open();
                    });
                });
            },

            initDvvButtonsPopup: function() {
                var _this = this;
                this.$popupFoldingControls = this.popup.$el.find('.folding-controls');
                this.$popupFoldingCloseBtn = this.popup.$el.find('button#popup-folding-close');
                this.$popupDvvPauseBtn = this.popup.$el.find('button#popup-dvv-pause');

                if (this.foldCode) {
                    this.resetDvvButtons();
                    this.$popupFoldingControls.show();
                } else {
                    this.$popupFoldingControls.hide();
                }

                this.$popupFoldingCloseBtn.on('click', function(event) {
                    _this.dvvAnimationChange(event, _this.DVVpopup);
                });

                this.$popupDvvPauseBtn.on('click', function(event) {
                    _this.dvvAnimationChange(event, _this.DVVpopup);
                });

                $(this.popupViewerSelector).on('click', function() {
                    _this.toggleDvvBtn(_this.$popupDvvPauseBtn, 'pause');
                });
            },

            loadDVVjs: function(dvvUrl) {
                var _this = this,
                    dvvPath = _.template(this.DVV_PATH)({ dvvUrl: dvvUrl });

                var script = document.createElement('script');
                script.src = dvvPath;
                document.body.appendChild(script);
                script.onload = function() {
                    _this.isLoaded = true;
                    _this.trigger('load:dvv');
                };
                script.onerror = function() {
                    _this.trigger('fail:load:dvv');
                };
            },

            generateDVVParams: function(params) {
                var _this = this;

                return {
                    name: params.isPopUpPreview ? 'DVV-popup' : 'DVV-primary',
                    onInit: function() {
                        if (params.isPopUpPreview) {
                            return _this.trigger('init:dvv-popup');
                        }
                        if (window.$ && typeof window.$.noConflict === 'function') {
                            // eliminates a conflict between jQuery on DVV side and Prototype on ONP side
                            window.$.noConflict();
                        }
                        _this.isInitialised = true;
                        _this.trigger('init:dvv');
                        $(_this.primaryViewerSelector)
                            .find('canvas')
                            .on('touchstart', function() {
                                _this.toggleDvvBtn(_this.$dvvPauseBtn, 'pause');
                            });
                    },
                    onLoadFailed: function() {
                        if (params.isPopUpPreview) {
                            return _this.trigger('fail:init:dvv-popup');
                        }
                        _this.trigger('fail:init:dvv');
                    },
                    onReady: function() {
                        _this.trigger('ready:dvv');
                    },
                    mouseWheelEnabled: params.isPopUpPreview == true,
                    lockAxis: params.lockAxis,
                    limitAxis: params.limitAxis,
                    worldAxis: params.worldAxis,
                    pages: [dvvPageParamsExtractor.parse(this.model, params)]
                };
            },

            // Folding Animation

            updateFolding: function(foldingTypeId, foldingMap) {
                this.isInverseFolding = false;
                var productSlug = this.model.get('productContext').get('slug');
                if (foldingTypeId == OptionValueModel.NAME_NONE_FOLD && productSlug.indexOf('gc') === 0) {
                    foldingTypeId = OptionValueModel.NAME_BI_FOLD;
                }
                if (foldingTypeId == OptionValueModel.NAME_BI_FOLD) {
                    this.$flipTopControl.prop('checked', false);
                    this.$flipTopControl.prop('disabled', true);
                } else {
                    this.$flipTopControl.prop('disabled', false);
                    this.isInverseFolding = this.$flipTopControl.prop('checked');
                }
                if (
                    (foldingTypeId === OptionValueModel.NAME_Z_FOLD || foldingTypeId === OptionValueModel.NAME_TRI_FOLD) &&
                    this.orientation === DesignModel.ORIENTATION_VERTICAL
                ) {
                    this.isInverseFolding = !this.$flipTopControl.prop('checked');
                }

                let showFoldingButton = false;
                this.foldCode = dvvPageParamsExtractor.getFoldCode(foldingTypeId, this.isInverseFolding, foldingMap);

                if (this.foldCode || this.model.get('optionsContext').get('folding') === OptionValueModel.NAME_CUSTOM_FOLDING) {
                    showFoldingButton = true;
                }

                this.resetDvvButtons();
                if (showFoldingButton) {
                    this.model.get('optionsContext').set('folding', foldingTypeId);
                    this.$foldingControls.show();
                } else {
                    this.$foldingControls.hide();
                }
            },

            resetDvvButtons: function() {
                this.toggleDvvBtn(this.$foldingCloseBtn, 'open');
                this.toggleDvvBtn(this.$dvvPauseBtn, 'play');

                if (
                    this.$popupFoldingCloseBtn &&
                    this.$popupFoldingCloseBtn.length &&
                    this.$popupDvvPauseBtn &&
                    this.$popupDvvPauseBtn.length
                ) {
                    this.toggleDvvBtn(this.$popupFoldingCloseBtn, 'open');
                    this.toggleDvvBtn(this.$popupDvvPauseBtn, 'play');
                }
            },

            dvvAnimationChange: function(event, DVV) {
                var $el = $(event.target);
                var action = $el.data('goto');
                var dvv = DVV || this.DVV;

                switch (action) {
                    case 'play':
                    case 'pause':
                        dvv.app.pause();
                        break;

                    case 'open':
                    case 'close':
                        dvv.app.animateFold({ action: action });
                }

                this.toggleDvvBtn($el, action);
            },

            toggleDvvBtn: function($element, actionName) {
                var action = this.dvvAnimation[actionName];

                $element.data('goto', action.goto).html(action.text);
            }
        });

        dvvPreview.isAvailable = function(productSlug) {
            const excludedProducts = [
                'booklets-55x85',
                'booklets-85x11',
                'booklets-a6-portrait',
                'booklets-a6-landscape',
                'booklets-a5-portrait',
                'booklets-a5-landscape',
                'booklets-a4-portrait'
            ];

            return browser.hasWebGL() && $.inArray(productSlug, excludedProducts) === -1 && productSlug.indexOf('calendar') !== 0;
        };

        return dvvPreview;
    }
);
